<template>
    <div class="the-detail-layout flex-grow-1 d-flex">
        <div class="the-detail-layout__aside d-flex">
            <slot name="aside"></slot>
        </div>

        <div class="the-detail-layout__main d-flex flex-column">
            <slot name="header"></slot>
            <slot name="body"></slot>
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TheDetailLayout'
};
</script>

<style lang="scss">
.the-detail-layout {
    position: relative;
    width: 1200px;
    margin-left: auto;
    margin-right: auto;

    &__aside {
        position: fixed;
        width: 300px;
        background: #f6f6f6;
        height: calc(100vh - 60px);
        z-index: 1;
    }

    &__main {
        width: 850px;
        left: 350px;
        position: relative;
    }
}
</style>
